module.exports = __webpack_public_path__ + "assets/img/00057.b5c8a406.png";